import React, { Fragment } from 'react';

import PickupOrder from '../../../models/PickupOrder';

import {Grid} from '@material-ui/core';

import style from './ordersStyle.module.css';

interface ManualEntryOrderDriverInfoProps {
  pickupOrder: PickupOrder;
};

const manualEntryOrderDriverInfo = (props: ManualEntryOrderDriverInfoProps) => {
  return(
    <Grid container className={ style.meGridContainer }>


      <Grid item className={ style.meInfoGridItem }>
        <div className={ style.infoWrapper}>
          <div className={ style.pot }> Drivers Name:</div>
          <div className={ style.pod }>{ props.pickupOrder.driver_name }</div>
        </div>
      </Grid>

      <Grid item className={ style.meInfoGridItem }>
        <div className={ style.infoWrapper}>
          <div className={ style.pot }> Driver's ID type:</div>
          <div className={ style.pod }>{ props.pickupOrder.driver_id_type }</div>
        </div>
      </Grid>

      <Grid item className={ style.meInfoGridItem }>
        <div className={ style.infoWrapper}>
          <div className={ style.pot }>Driver's ID:</div>
          <div className={ style.pod }>{ props.pickupOrder.driver_id }</div>
        </div>
      </Grid>

      <Grid item className={ style.meInfoGridItem }>
        <div className={ style.infoWrapper}>
          <div className={ style.pot }> Trucking Company:</div>
          <div className={ style.pod }>{ props.pickupOrder.delivery_company_name }</div>
        </div>
      </Grid>

    </Grid>
  )
}

export default manualEntryOrderDriverInfo;